import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';

export default function ToolTip({
    message,
    target,
    isOpen,
    placement,
    tooltipKey,
}: any) {
    const [hover, setHover] = useState(false);
    const tooltipIsOpen = isOpen !== undefined ? isOpen : hover;
    return (
        <Tooltip
            style={{
                maxWidth: '400px',
            }}
            key={tooltipKey ?? "tooltip"}
            placement={placement ?? 'bottom'}
            id={`tooltip_${target}`}
            isOpen={tooltipIsOpen}
            target={target}
            toggle={() => setHover(!hover)}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            {message}
        </Tooltip>
    );
}
